export const CUSTOM_MODAL_TYPES = {
  TEXT: "text",
  COMPLETED: "completed",
  RADIO: "radio",
  SCHEDULE: "schedule",
  RATING: "rating",
  INC_PROFILE: "incomplete_profile",
  INC_MCLE_PROFILE: "incomplete_mcle_profile",
  VERIFY_EMAIL: "email",
  INC_KYC: "incomplete_kyc",
  NO_CLASS: "no_class",
  SELECT_CLASS: "select_class",
  NOT_STUDENT: "not_student",
  COURSE_NOT_OPEN: "course_not_open",
  COURSE_ENDED: "course_ended",
  ANNOUNCEMENT: "announcement",
  PAY_LATER: "pay_later",
}

export const RESPONSE_MODAL_TYPES = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
}

export const FORUM_MODAL_TYPES = {
  QUESTION: "forum_question",
  COMMENT: "question_comment",
  ANSWER: "question_answer",
}
